import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Table, Button, Badge } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteEnquiryData, getEnquiryList } from "../../redux/actions/EnquiryActions";
import RoundedPagination from "../../Components/Paginate";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from "../../util/generalUtills";
import Preloader from "../../Components/Preloader";
import EnquiryNote from "../../Components/FormComponent/EnquiryNote";
import EnquiryNoteWithFileUpload from "../../Components/FormComponent/EnquiryNoteWithFileUpload";


const Enquiries = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showModalQuotation, setShowModalQuotation] = useState(false);
    const [enquiryId, setEnquiryId] = useState(null);
    const [enquiriesListing, setEnquiriesListing] = useState([]);
    const [enquiriesNotesListing, setEnquiriesNotesListing] = useState([]);
    const [total, setTotal] = useState(0);
    const {
        AuthReducer: { auth, errors, loading },
        enquiryReducer: {
            enquiryLists,
            loadingEnquiry,
            errorsEnquiry,
            enquiryCount,
            changedEnquiryStatus,
        },
    } = useSelector((state) => state);
    const [page, setPage] = useState(1);
    const [paginate, setPaginate] = useState(10);
    const [search, setSearch] = useState("");
    const [sort, setSort] = useState('desc');
    const indexOfLastItem = (page + 1) * paginate;
    const indexOfFirstItem = indexOfLastItem - paginate;

    const hideModel = () => {
        setShowModal(false);
        setEnquiryId(null);
        dispatch(getEnquiryList(auth.token, paginate, page, search, sort));
    };
    const hideModelQuotation = () => {
        setShowModalQuotation(false);
        setEnquiryId(null);
        dispatch(getEnquiryList(auth.token, paginate, page, search, sort));
    };
    useEffect(() => {
        if (enquiryLists) {
            setEnquiriesListing(enquiryLists?.data);
            setPage(enquiryLists?.current_page);
            setTotal(enquiryLists?.total);
            setPaginate(enquiryLists?.per_page);
        }
    }, [enquiryLists])
    const fetchEnquiryList = useCallback(() => {
        if (auth?.token) {
            dispatch(getEnquiryList(auth.token, paginate, page, search, sort));
        }
    }, [auth, paginate, page, search, sort, dispatch]);

    useDebounce(fetchEnquiryList, 500, [auth, paginate, page, search, sort]);

    useEffect(() => {
        if (errors) {
            if (errors?.status === 401) {
                dispatch(logout());
                toast.error(errors?.data?.message);
                navigate('/login');
                window.location.reload();
            }
        }
    }, [errors]);

    const handlePaginateChange = (e) => {
        const value = e.target.value === "All" ? enquiryCount : parseInt(e.target.value);
        setPaginate(value);
        setPage(1);
    };

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const handleDeleteRequest = (id) => {
        swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28bb4b",
            cancelButtonColor: "#f34e4e",
            confirmButtonText: "Yes, delete it!",
        })
            .then((result) => {
                if (result.isConfirmed) {
                    dispatch(deleteEnquiryData(auth?.token, id));
                }
            });
    };

    useEffect(() => {
        if (changedEnquiryStatus?.status) {
            swal.fire({
                show: true,
                title: "Changed!",
                text: changedEnquiryStatus?.message,
                icon: "success",
                showConfirmButton: false,
                timer: 1500
            });
            dispatch({ type: 'RESET_ENQUIRY_STATUS' });
            dispatch(getEnquiryList(auth?.token, paginate, page, search, sort));
        }
    }, [changedEnquiryStatus]);

    return (
        <>
            <PageTitle
                breadCrumbItems={[{ label: t("Enquiries"), path: "/Enquiries", active: true }]}
                title={t("Enquiries")}
            />

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <div className="mb-2">
                                <Row>
                                    <Col lg={3}>
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="search"
                                                placeholder="Search..."
                                                className="form-control ms-1"
                                                autoComplete="off"
                                                value={search}
                                                onChange={handleSearchChange}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={9}>
                                        <div className="d-flex justify-content-end align-items-center">
                                            <div className="button-list">
                                                {/* <Button variant="dark">
                                                    <i className="mdi mdi-printer me-1"></i>Print
                                                </Button>
                                                <Button variant="info">
                                                    <i className="mdi mdi-file-excel me-1"></i>Excel
                                                </Button> */}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            <div>
                                <Table className="mb-0 table-sm" responsive="sm" striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Sr No.</th>
                                            <th>Name</th>
                                            <th>Mobile</th>
                                            <th>Email</th>
                                            <th>Products</th>
                                            <th>Last Note</th>
                                            <th>Enquired On</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {enquiriesListing?.length === 0 ? (
                                            <tr>
                                                <td colSpan="6">No data found</td>
                                            </tr>
                                        ) : (
                                            enquiriesListing?.map((item, index) => (
                                                <tr key={item.id}>
                                                    <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                                                    <td>{item?.user?.name}</td>
                                                    <td>{item?.user?.mobile}</td>
                                                    <td>{item?.user?.email}</td>
                                                    <td>{item?.products?.map((product, index) => (
                                                        <span className="badge bg-primary me-1">{product?.name}</span>
                                                    )
                                                    )}
                                                    </td>
                                                    <td>{item?.notes?.length > 0 && (
                                                        <>
                                                            <span className="me-1"><strong>Title : </strong> {item?.notes[0]?.title}</span><br />
                                                            <span className="me-1"><strong>Disposition : </strong> {item?.notes[0]?.disposition}</span><br />
                                                            <span className="me-1"><strong>Description : </strong> {item?.notes[0]?.note}</span>
                                                        </>
                                                    )}
                                                    </td>
                                                    <td>{getDisplayDateTimeFormat(item?.created_at)}</td>
                                                    <td>
                                                        <Link to="#" className="action-icon text-warning" onClick={() => {
                                                            setShowModal(true);
                                                            setEnquiryId(item?.id);
                                                            setEnquiriesNotesListing(item?.notes)

                                                        }}>
                                                            <i className="mdi mdi-note-plus"></i>
                                                        </Link>
                                                        <Link to="#" className="action-icon text-danger" onClick={() => handleDeleteRequest(item?.id)}>
                                                            <i className="mdi mdi-delete"></i>
                                                        </Link>
                                                        <Link to="#" className="action-icon text-danger" onClick={() => {
                                                            setShowModalQuotation(true);
                                                            setEnquiryId(item?.id);
                                                        }}>
                                                            <i className="mdi mdi-mail"></i>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            </div>

                            <div className="mt-3 d-lg-flex align-items-center text-center pb-1">
                                <div className="d-inline-block me-3">
                                    <label className="me-1">Display:</label>
                                    <select className="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                                <span className="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(total / paginate)}</strong> </span>
                                <RoundedPagination currentPage={page} totalPages={Math.ceil(total / paginate)} onPageChange={(pageNumber) => setPage(pageNumber)} />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <EnquiryNote show={showModal} onHide={hideModel} enquiryid={enquiryId} enquiryNoteLists={enquiriesNotesListing} />
            <EnquiryNoteWithFileUpload show={showModalQuotation} onHide={hideModelQuotation} enquiryid={enquiryId} />
            {loadingEnquiry && (<Preloader />)}
        </>
    );
};

export default Enquiries;
